import { GotoGalleryApp } from '@/views/goto-gallery-app'
import { GallerySkeleton } from '@/views/gallery-skeleton'
import { GalleryHeader } from '@/views/gallery-header'
import { GalleryToolbar } from '@/views/gallery-toolbar'
import { GalleryTilesView } from '@/views/gallery-tiles-view'
import { GalleryListView } from '@/views/gallery-list-view'
import { GalleryDetailsView } from '@/views/gallery-details-view'
import { GalleryError } from '@/views/gallery-error'

/**
 * Maps custom element tag names to their constructor classes.
 */
export type ComponentRegistry = Record<string, CustomElementConstructor>

/**
 * The application component registry.
 * Add each new component's tag name and constructor here.
 */
export const registry: ComponentRegistry = {
  [GotoGalleryApp.tagName]: GotoGalleryApp,
  [GallerySkeleton.tagName]: GallerySkeleton,
  [GalleryHeader.tagName]: GalleryHeader,
  [GalleryToolbar.tagName]: GalleryToolbar,
  [GalleryTilesView.tagName]: GalleryTilesView,
  [GalleryListView.tagName]: GalleryListView,
  [GalleryDetailsView.tagName]: GalleryDetailsView,
  [GalleryError.tagName]: GalleryError,
}

/**
 * Registers all components in the provided registry with the browser's
 * Custom Elements registry. Each component is only registered once —
 * subsequent calls with the same tag name are silently skipped.
 */
export function registerComponents(componentRegistry: ComponentRegistry): void {
  for (const [tagName, ctor] of Object.entries(componentRegistry)) {
    if (!customElements.get(tagName)) {
      customElements.define(tagName, ctor)
    }
  }
}
